import { render } from "./MakerLogo.vue?vue&type=template&id=70c57b07"
import script from "./MakerLogo.vue?vue&type=script&lang=js"
export * from "./MakerLogo.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__